import Address from '../../../AddressBuilder.js'

const _path = {
  CHJBXXB: Address.business('bzdzChjbxxb', Address.CONFIG.VERSION.version_1)
}

export default {
  getChjg(_parameter) { // 获取层户结构
    return sHttp.postJson(_path.CHJBXXB + 'findChjgxxS', _parameter)
  },

  getChjgSjzy(param) { // 获取层户结构 数据资源
    let _parameter = {dzbm: param}
    return sHttp.postJson(_path.CHJBXXB + 'findBzdzSjzyByDzbm', _parameter)
  },

  add(_parameter) { // 保存层户结构
    return sHttp.postJson(_path.CHJBXXB + 'addBatch', _parameter)
  },

  findHsdz(_parameter) {// 标准地址--获取户室地址下拉框
    return sHttp.postJson(_path.CHJBXXB + 'findHsdzBox', _parameter)
  },
}
